import { Card, Row, Col, Badge, Progress, Typography } from "antd";
import { FileOutlined, CheckCircleOutlined, ExclamationCircleOutlined, CloseCircleOutlined, } from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartSimple, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const { Title, Text, Paragraph } = Typography;

export function OverviewDashboard({ globalStats, projectCount, hidenMenu, ocultarData }) {
  const validationRate =
    globalStats.total > 0
      ? Math.round((globalStats.validated / globalStats.total) * 100)
      : 0;

  const metrics = [
    {
      title: "Total de Archivos",
      value: globalStats.total,
      icon: <FileOutlined style={{ color: "#338BC7", fontSize: 32 }} />,
      color: "#338BC7",
    },
    {
      title: "Archivos Validados",
      value: globalStats.validated,
      icon: <CheckCircleOutlined style={{ color: "#009728", fontSize: 32 }} />,
      color: "#009728",
    },
    {
      title: "Sin Validar",
      value: globalStats.notValidated,
      icon: <ExclamationCircleOutlined style={{ color: "#F8C340", fontSize: 32 }} />,
      color: "#F8C340",
    },
    {
      title: "Sin Registrar",
      value: globalStats.notRegistered,
      icon: <CloseCircleOutlined style={{ color: "#FF4D4F", fontSize: 32 }} />,
      color: "#FF4D4F",
    },
  ];

  return (
    <div style={{ overflowX: "hidden", width: "100%" }}>
      <Card
        style={{
          borderRadius: 8,
          overflow: "hidden",
          border: "1px solid #e8e8e8",
        }}
      >
        {/* HEADER */}
        <div
          style={{
            background: "#042956",
            color: "white",
            padding: "16px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap", // 👈 para evitar desborde en pantallas pequeñas
            gap: "12px",
          }}
        >
          <div>
            <Title level={3} style={{ margin: 0, color: "white" }}>
              <FontAwesomeIcon onClick={hidenMenu} icon={ocultarData ? faEyeSlash : faEye} style={{ marginRight: 10 }} />
              <FontAwesomeIcon icon={faChartSimple} style={{ marginRight: 10 }} />
              Resumen General
            </Title>
            <Paragraph style={{ margin: 0, color: "#d9d9d9" }}>
              Vista global del estado de validación de archivos
            </Paragraph>
          </div>

          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            <Badge
              count={`${projectCount} Proyectos Activos`}
              style={{
                backgroundColor: "#338BC7",
                color: "#fff",
                fontWeight: "bold",
              }}
            />
            <Badge
              count={`${validationRate}% Validado`}
              style={{
                backgroundColor:
                  validationRate >= 80
                    ? "#52c41a"
                    : validationRate >= 50
                      ? "#faad14"
                      : "#ff4d4f",
                color: "#fff",
                fontWeight: "bold",
              }}
            />
          </div>
        </div>
      </Card>
      <Row gutter={[16, 16]} style={{ marginTop: 24, flexWrap: "wrap" }}>
        {metrics.map((metric) => (
          <Col xs={24} sm={12} md={12} lg={6} key={metric.title}>
            <Card
              hoverable
              style={{
                height: "140px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                padding: "16px",
                borderRadius: "8px",
              }}
            >
              <Row align="middle" justify="center" style={{ height: "100%" }}>
                <Col style={{ textAlign: "center" }}>
                  <Text strong>{metric.title}</Text>
                  <div style={{ height: 8, margin: "0 auto" }}>
                    <div
                      style={{
                        width: 20,
                        height: 4,
                        backgroundColor: metric.color,
                        borderRadius: 2,
                        margin: "0 auto",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                      fontSize: 28,
                      fontWeight: "bold",
                      color: metric.color,
                      marginTop: 12,
                    }}
                  >
                    {metric.icon}
                    <span>{metric.value}</span>
                  </div>
                  {metric.title === "Archivos Validados" && (
                    <Text type="secondary">{validationRate}% del total</Text>
                  )}
                </Col>
              </Row>
            </Card>
          </Col>
        ))}
      </Row>
      <Row gutter={[16, 16]} style={{ marginTop: 24, flexWrap: "wrap" }}>
        <Col xs={24} lg={12}>
          <Card
            hoverable
            style={{
              borderRadius: 8,
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
            styles={{
              body: {
                flex: 1,
                padding: "16px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              },
            }}
          >
            <div
              style={{
                backgroundColor: "#042956",
                color: "white",
                textAlign: "center",
                fontSize: "20px",
                fontWeight: "bold",
                padding: "12px 16px",
                borderTopLeftRadius: 8,
                borderTopRightRadius: 8,
              }}
            >
              Estado de Validación
            </div>
            <div style={{ padding: "16px" }}>
              {["validated", "notValidated", "notRegistered"].map((key) => {
                const label =
                  key === "validated"
                    ? "Validados"
                    : key === "notValidated"
                      ? "Sin Validar"
                      : "Sin Registrar";
                const value = globalStats[key];
                const color =
                  key === "validated"
                    ? "#009728"
                    : key === "notValidated"
                      ? "#F8C340"
                      : "#FF4D4F";
                const percent = globalStats.total
                  ? Math.round((value / globalStats.total) * 100)
                  : 0;

                return (
                  <div key={key} style={{ marginBottom: 16 }}>
                    <Row justify="space-between">
                      <Text strong>{label}</Text>
                      <Text strong>
                        {value} ({percent}%)
                      </Text>
                    </Row>
                    <Progress percent={percent} strokeColor={color} showInfo={false} />
                  </div>
                );
              })}
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            hoverable
            style={{
              borderRadius: 8,
              overflow: "hidden",
              display: "flex",
              height: "100%",
              flexDirection: "column",
            }}
            styles={{
              body: {
                flex: 1,
                padding: "16px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              },
            }}
          >
            <div
              style={{
                backgroundColor: "#042956",
                color: "white",
                textAlign: "center",
                fontSize: "20px",
                fontWeight: "bold",
                padding: "12px 16px",
                borderTopLeftRadius: 8,
                borderTopRightRadius: 8,
              }}
            >
              Progreso de Validación
            </div>
            <div
              style={{
                padding: "16px",
                flex: 1,
                textAlign: "center",
                fontSize: 20,
              }}
            >
              <Text strong>Progreso General: {validationRate}%</Text>
              <Progress
                percent={validationRate}
                strokeColor="#338BC7"
                style={{ marginTop: 12 }}
              />
              <div style={{ marginTop: 16 }}>
                <Text type="secondary">Meta de validación: 100%</Text>
                <br />
                <Text type="secondary">
                  Archivos restantes:{" "}
                  {globalStats.notValidated + globalStats.notRegistered}
                </Text>
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
